import { ENVS } from '../../../lib/env'

export const FEATURE_ENABLE_CONTROL_ON_DISCOUNT = 'enable_control_on_discount'
export const FEATURE_ENABLE_REGISTER_ACCESS_CONTROL =
  'enable_register_access_control'
export const REACT_CONFIRMATION_PANEL = 'react_confirmation_panel'
export const FEATURE_DEPRECATE_VD_ACTIVE_USER = 'deprecate_vd_active_user'
export const FEATURE_ROUND_TO_2DP_BEFORE_SENDING = 'round_to_2dp_before_sending'
export const FEATURE_ENABLE_INVOICING_PAYMENT_REQUESTS =
  'invoicing_payment_requests'
export const FEATURE_ENABLE_INVOICING_NON_FULFILLMENT_PAYMENT_REQUESTS =
  'invoicing_non_fulfillment_payment_requests'
export const FEATURE_ENABLE_INVOICING_QUOTE_PAYMENT_REQUESTS =
  'invoicing_quote_payment_requests'
export const FEATURE_ENABLE_INVOICING_PAYMENT_REQUEST_QUOTE_DELIVERY =
  'invoicing_payment_request_quote_delivery'
export const FEATURE_ENABLE_INVOICING_PAYMENT_REQUEST_AU_COMPLIANCE =
  'invoicing_payment_request_au_compliance'
export const FEATURE_ENABLE_INVOICING_PAYMENT_METHOD_SETTINGS =
  'invoicing_payment_method_settings'
export const FEATURE_ENABLE_INVOICING_QUOTE_SERVICE = 'invoicing_quote_service'
export const LRX_32023_MARK_ALL_ITEMS_FULFILLED =
  'LRX-32023_mark_all_items_fulfilled'
export const FEATURE_NEW_TAX_EXEMPTION_ENABLED = 'new_tax_exemption_enabled'
export const FEATURE_BARCODE_FROM_SALE_ID = 'LRX-33927-barcode_from_sale_id'
export const FEATURE_FULFILLMENT_TAKE_NOW_ITEM_PAYMENT_ENFORCEMENT =
  'fulfillment_take_now_item_payment_enforcement'
export const FEATURE_ALLOW_EDIT_UNFULFILLED_SALES =
  'allow_edit_unfulfilled_sales'
export const FEATURE_ALLOW_EDIT_UNFULFILLED_SALES_CANCEL_SALE =
  'allow_edit_unfulfilled_sales_cancel_sale'
export const FEATURE_USE_2026_04_INVENTORY_API =
  'if_isp1_use_2026_04_inventory_api'
export const FEATURE_BARCODE_SCAN_ERROR_FIX = 'LRX_26016_barcode_scan_error_fix'
export const FEATURE_SSBO_ONBOARDING_COHORT = 'ssbo_onboarding_cohort'
export const FEATURE_ON_ACCOUNT_PAYMENT_TYPE = 'on_account_payment_type'
export const FEATURE_ON_ACCOUNT_LAYBY_BALANCE_SPLIT =
  'on_account_layby_balance_split'
export const FEATURE_ENABLE_SERVICE_ORDERS = 'enable_service_orders'
export const FEATURE_ON_ACCOUNT_PAY_VIA_REGISTER = 'on_account_pay_via_register'
export const FEATURE_ENABLE_ACH_XSERIES = 'enable_ach_xseries'
export const FEATURE_SURCHARGE_TRANSLATION = 'surcharge_translation'
export const FEATURE_SHOW_SPECIAL_ORDERS_IN_INVENTORY =
  'if_isp1_show_quantity_to_procure'
export const FEATURE_COMPLETE_PICKUP_AFTER_PAYMENT =
  'complete_pickup_after_payment'
export const FEATURE_REGISTER_BASEPRICE_AS_BESTPRICE =
  'register_baseprice_as_bestprice'
export const LRX_39416_STALE_OFFLINE_SALE_REMEDIATION =
  'LRX-39416_stale-offline-sale-remediation'
export const FEATURE_VALIDATE_RETURN_QUANTITIES =
  'LRX_37470_validate_return_quantities'
export const FEATURE_XMEN2565_RECEIPT_WEB_PRESENCE =
  'XMEN2565_receipt_web_presence'
export const FEATURE_FAILFAST_BULK_SOLD_BY = 'Failfast-bulk-sold-by'
export const FEATURE_CROSS_LOCATION_FULFILMENT =
  'LRX-37996_selling_outlet_pay_clf'
export const FEATURE_LSPAY_CNP_PAYMENTS = 'lspay_cnp_payments'
export const FEATURE_LSPAY_CP_CNP_SPLIT_ENTRY = 'lspay_cp_cnp_split_entry'
export const FEATURE_UC_IN_WEBREGISTER_LOCK_ICON = 'uc_in_webregister_lock_icon'
export const FEATURE_UC_IN_WEBREGISTER_NOTE_INPUT =
  'uc_in_webregister_note_input'
export const FEATURE_UC_IN_WEBREGISTER_INPUT_ERROR =
  'uc_in_webregister_input_error'
export const FEATURE_UC_IN_WEBREGISTER_DELETE_BUTTON =
  'uc_in_webregister_delete_button'
export const FEATURE_UC_IN_WEBREGISTER_LINE_ITEM_DETAILS =
  'uc_in_webregister_line_item_details'
export const FEATURE_UC_IN_WEBREGISTER_SPECIAL_ORDER_PRODUCT_TAG =
  'uc_in_webregister_special_order_product_tag'
export const FEATURE_LSPAY_CASH_DISCOUNTING = 'lspay_cash_discounting'
export const FEATURE_LSPAY_PENDING_SALE_FINALIZATION =
  'lspay_pending_sale_finalization'
export const LRX_28094_COLLAPSIBLE_CASH_COUNTING =
  'LRX_28094_collapsible_cash_counting'
export const LRX_39407_CHEQUE_REFERENCE_WRITE =
  'LRX-39407_cheque_reference_write'
export const LRX_39407_CHEQUE_REFERENCE_READ = 'LRX-39407_cheque_reference_read'
export const FEATURE_STANDALONE_CUSTOMER_FACING_DISPLAY_ENABLED =
  'standalone_customer_facing_display_enabled'
export const FEATURE_LSPAY_ABLY_AUTHCALLBACK_ENABLED =
  'lspay_ably_authcallback_enabled'
export const FEATURE_LRX_38368_MIGRATE_LEGACY_VERSION_REGISTER_SALES_WEBREGISTER =
  'LRX_38368_migrate_legacy_version_register_sales_webregister'
export const FEATURE_LRX_42862_HIDE_ECOM_REGISTERS =
  'LRX-42862-hide-ecom-registers'
export const FEATURE_LSPAY_GROWTH_EXPERIMENT_UI = 'lspay_growth_experiment_ui'
export const FEATURE_XEO_2536_STORE_CREDIT_EARNS_LOYALTY =
  'XEO-2536_store_credit_earns_loyalty'
export const FEATURE_REGISTER_PERF_OPTIMIZATIONS =
  'LRX-18460_register_perf_optimizations'
export const LRX_23910_ENABLE_DEFAULT_VALUE_ON_BOOLEAN_CUSTOM_FIELD =
  'LRX_23910_enable_default_value_on_boolean_custom_field'
export const FEATURE_LRX_43242_PRESERVE_WORKFLOWS_BLOCKING_OUTCOME =
  'LRX-43242_preserve_workflows_blocking_outcome'
export const FEATURE_INTEGRATED_PAYMENT_OVERPAYMENT_FIX =
  'integrated_payment_overpayment_fix'

/**
 * Constants related to the feature flags in use within web register.
 *
 * This is a map of feature name to default value (per environment).
 *
 * Only specify features that are currently in use.
 * Always specify a sensible default value for the production environment.
 * Specify a sensible override for test/development environments if applicable.
 * Clean up features from here when they are no longer needed.
 *
 * @module webregister.constants.WR_FEATURES
 */
export const WR_FEATURES = {
  // Declare the default fallback value of each feature for production environments here
  [ENVS.PRODUCTION]: {
    // Feature flags based on retailer subscription plan
    gift_receipts: false,
    [FEATURE_ROUND_TO_2DP_BEFORE_SENDING]: false,
    promotions: false,
    promotions_advanced: false,
    customer_groups: true,
    // Selective features: These features cannot be rolled out 100% but can
    // only be enabled per retailer
    cash_discounting: false,
    // If you don't specify your feature flag here, it wont be requested in production and so will always be false
    direct_econduit: false,
    parked_sales_from_read_api: false,
    payment_type_controls: false,
    terminal_tipping: false,
    lspay_customer_facing_display_enabled: false,
    [FEATURE_STANDALONE_CUSTOMER_FACING_DISPLAY_ENABLED]: false,
    [FEATURE_LSPAY_ABLY_AUTHCALLBACK_ENABLED]: false,
    [FEATURE_LSPAY_CNP_PAYMENTS]: true,
    lspay_international_unreferenced_refunds: false,
    lspay_payment_links: false,
    lspay_pay_with_server_driven: false,
    lspay_refund_with_server_driven: false,
    lspay_referenced_refund_with_server_driven: false,
    lspay_pay_with_quick_pay_experiment: false,
    lspay_server_driven_override: false,
    lspay_surcharge: false,
    lspay_cash_discounting: false,
    [FEATURE_LSPAY_PENDING_SALE_FINALIZATION]: false,
    lspay_surcharge_xero_onaccount: false,
    lspay_surcharge_qbo_onaccount: false,
    lspay_terminal_status_enabled: false,
    lspay_terminal_status_connection_logging_enabled: false,
    lspay_tipping_on_pre_tax_amount: false,
    raise_lspay_button_on_payment_screen_experiment: false,
    lspay_unreferenced_refund: false,
    lspay_simulated_reader: false,
    lspay_eseries_refunds_on_xseries: false,
    swiper_sandbox_lspay: false,
    enable_on_account_limit_enforcement: false,
    sales_person_attribution: false,
    fulfill_from_another_outlet: false,
    has_qbo: false,
    pufs_ignore_accounting_integrations: false,
    react_workflows: false,
    custom_fields_on_receipt: false,
    payment_integration_origin_validation: false,
    create_new_sale_after_validating: false,
    validate_new_sale: false,
    use_create_sale_endpoint: false,
    [LRX_39416_STALE_OFFLINE_SALE_REMEDIATION]: false,
    limit_product_images_in_webregister: false,
    register_closure_reminder_A: false,
    register_closure_reminder_B: false,
    register_closure_reminder_lspay: false,
    auxiliary_lspay_active_pli: false,
    [FEATURE_ENABLE_SERVICE_ORDERS]: false,
    [FEATURE_ON_ACCOUNT_LAYBY_BALANCE_SPLIT]: false,
    register_online_only_customers_webregister: false,
    register_remove_local_customer_data_webregister: false,
    swiper_check_payment_type_available_jit: false,
    webregister_react_select_register: false,
    [FEATURE_ENABLE_CONTROL_ON_DISCOUNT]: false,
    increase_variant_limit: false,
    [FEATURE_ENABLE_REGISTER_ACCESS_CONTROL]: false,
    // Disables Transifex translations from being fetched
    disable_translation: false,
    new_user_switching_in_app: false,
    enable_permission_park_sale_check: false,
    omni_gift_cards: false,
    omni_gift_cards_allow_short_codes: false,
    [FEATURE_DEPRECATE_VD_ACTIVE_USER]: false,
    [REACT_CONFIRMATION_PANEL]: true,
    react_gift_card_modals: false,
    track_offline_sale_metadata: false,
    enable_customer_saved_cards: false,
    lspay_show_repeat_card_detection: false,
    [FEATURE_ENABLE_INVOICING_PAYMENT_REQUESTS]: false,
    [FEATURE_ENABLE_INVOICING_NON_FULFILLMENT_PAYMENT_REQUESTS]: false,
    [FEATURE_ENABLE_INVOICING_QUOTE_PAYMENT_REQUESTS]: false,
    [FEATURE_ENABLE_INVOICING_PAYMENT_REQUEST_QUOTE_DELIVERY]: false,
    [FEATURE_ENABLE_INVOICING_PAYMENT_REQUEST_AU_COMPLIANCE]: false,
    [FEATURE_ENABLE_INVOICING_PAYMENT_METHOD_SETTINGS]: false,
    [FEATURE_ENABLE_INVOICING_QUOTE_SERVICE]: false,
    [LRX_32023_MARK_ALL_ITEMS_FULFILLED]: false,
    inventory_special_orders: false,
    [FEATURE_SHOW_SPECIAL_ORDERS_IN_INVENTORY]: false,
    [FEATURE_NEW_TAX_EXEMPTION_ENABLED]: false,
    [FEATURE_BARCODE_FROM_SALE_ID]: false,
    [FEATURE_FULFILLMENT_TAKE_NOW_ITEM_PAYMENT_ENFORCEMENT]: true,
    [FEATURE_ALLOW_EDIT_UNFULFILLED_SALES]: false,
    [FEATURE_ALLOW_EDIT_UNFULFILLED_SALES_CANCEL_SALE]: false,
    [FEATURE_USE_2026_04_INVENTORY_API]: false,
    [FEATURE_BARCODE_SCAN_ERROR_FIX]: false,
    [FEATURE_SSBO_ONBOARDING_COHORT]: false,
    [FEATURE_ON_ACCOUNT_PAYMENT_TYPE]: false,
    [FEATURE_ON_ACCOUNT_PAY_VIA_REGISTER]: false,
    [FEATURE_ENABLE_ACH_XSERIES]: false,
    [FEATURE_SURCHARGE_TRANSLATION]: false,
    [FEATURE_COMPLETE_PICKUP_AFTER_PAYMENT]: false,
    [FEATURE_REGISTER_BASEPRICE_AS_BESTPRICE]: false,
    [FEATURE_VALIDATE_RETURN_QUANTITIES]: false,
    [FEATURE_XMEN2565_RECEIPT_WEB_PRESENCE]: false,
    [FEATURE_LRX_42862_HIDE_ECOM_REGISTERS]: false,
    [FEATURE_FAILFAST_BULK_SOLD_BY]: false,
    [FEATURE_CROSS_LOCATION_FULFILMENT]: false,
    [FEATURE_LSPAY_CP_CNP_SPLIT_ENTRY]: false,
    [FEATURE_UC_IN_WEBREGISTER_LOCK_ICON]: false,
    [FEATURE_UC_IN_WEBREGISTER_NOTE_INPUT]: false,
    [FEATURE_UC_IN_WEBREGISTER_INPUT_ERROR]: false,
    [FEATURE_UC_IN_WEBREGISTER_DELETE_BUTTON]: false,
    [FEATURE_UC_IN_WEBREGISTER_LINE_ITEM_DETAILS]: false,
    [FEATURE_UC_IN_WEBREGISTER_SPECIAL_ORDER_PRODUCT_TAG]: false,
    [LRX_28094_COLLAPSIBLE_CASH_COUNTING]: false,
    [LRX_39407_CHEQUE_REFERENCE_WRITE]: false,
    [LRX_39407_CHEQUE_REFERENCE_READ]: false,
    [FEATURE_LRX_38368_MIGRATE_LEGACY_VERSION_REGISTER_SALES_WEBREGISTER]: false,
    [FEATURE_LSPAY_GROWTH_EXPERIMENT_UI]: false,
    [FEATURE_XEO_2536_STORE_CREDIT_EARNS_LOYALTY]: false,
    [FEATURE_REGISTER_PERF_OPTIMIZATIONS]: false,
    [LRX_23910_ENABLE_DEFAULT_VALUE_ON_BOOLEAN_CUSTOM_FIELD]: false,
    [FEATURE_LRX_43242_PRESERVE_WORKFLOWS_BLOCKING_OUTCOME]: false,
    [FEATURE_INTEGRATED_PAYMENT_OVERPAYMENT_FIX]: false,
  },
  // Declare test environment overrides here
  [ENVS.TEST]: {
    promotions: true,
    [FEATURE_XMEN2565_RECEIPT_WEB_PRESENCE]: true,
    [FEATURE_ALLOW_EDIT_UNFULFILLED_SALES]: true,
    [FEATURE_ALLOW_EDIT_UNFULFILLED_SALES_CANCEL_SALE]: true,
  },
  // Declare development environment overrides here
  [ENVS.DEVELOPMENT]: {
    cash_discounting: false,
    dark_mode: false,
    promotions_advanced: false,
    terminal_tipping: true,
    parked_sales_from_read_api: true,
    payment_type_controls: false,
    customer_groups: true,
    fulfill_from_another_outlet: true,
    has_qbo: false,
    pufs_ignore_accounting_integrations: false,
    react_workflows: true,
    custom_fields_on_receipt: true,
    payment_integration_origin_validation: true,
    create_new_sale_after_validating: true,
    validate_new_sale: true,
    enable_on_account_limit_enforcement: true,
    use_create_sale_endpoint: true,
    [LRX_39416_STALE_OFFLINE_SALE_REMEDIATION]: false,
    limit_product_images_in_webregister: true,
    [FEATURE_ROUND_TO_2DP_BEFORE_SENDING]: false,
    register_closure_reminder_A: false,
    register_closure_reminder_B: false,
    register_closure_reminder_lspay: true,
    auxiliary_lspay_active_pli: false,
    lspay_customer_facing_display_enabled: false,
    [FEATURE_STANDALONE_CUSTOMER_FACING_DISPLAY_ENABLED]: true,
    [FEATURE_LSPAY_ABLY_AUTHCALLBACK_ENABLED]: false,
    lspay_payment_links: false,
    lspay_pay_with_server_driven: false,
    lspay_refund_with_server_driven: false,
    lspay_referenced_refund_with_server_driven: false,
    lspay_server_driven_override: false,
    lspay_surcharge: false,
    lspay_cash_discounting: false,
    [FEATURE_LSPAY_PENDING_SALE_FINALIZATION]: true,
    lspay_surcharge_xero_onaccount: false,
    lspay_surcharge_qbo_onaccount: false,
    lspay_pay_with_quick_pay_experiment: false,
    lspay_terminal_status_enabled: false,
    lspay_terminal_status_connection_logging_enabled: false,
    lspay_tipping_on_pre_tax_amount: false,
    raise_lspay_button_on_payment_screen_experiment: false,
    sales_person_attribution: true,
    [FEATURE_ENABLE_SERVICE_ORDERS]: true,
    [FEATURE_ON_ACCOUNT_LAYBY_BALANCE_SPLIT]: true,
    register_online_only_customers_webregister: false,
    register_remove_local_customer_data_webregister: false,
    swiper_check_payment_type_available_jit: false,
    webregister_react_select_register: true,
    [FEATURE_ENABLE_CONTROL_ON_DISCOUNT]: false, // false for now, we don't want to change behavior for all devs yet
    increase_variant_limit: false,
    [FEATURE_ENABLE_REGISTER_ACCESS_CONTROL]: false,
    disable_translation: false,
    new_user_switching_in_app: false,
    enable_permission_park_sale_check: true,
    omni_gift_cards: false,
    omni_gift_cards_allow_short_codes: false,
    frontend_metrics: false,
    track_offline_sale_metadata: false,
    enable_customer_saved_cards: false,
    lspay_show_repeat_card_detection: false,
    [FEATURE_ENABLE_INVOICING_PAYMENT_REQUESTS]: true,
    [FEATURE_ENABLE_INVOICING_NON_FULFILLMENT_PAYMENT_REQUESTS]: true,
    [FEATURE_ENABLE_INVOICING_QUOTE_PAYMENT_REQUESTS]: true,
    [FEATURE_ENABLE_INVOICING_PAYMENT_REQUEST_QUOTE_DELIVERY]: true,
    [FEATURE_ENABLE_INVOICING_PAYMENT_REQUEST_AU_COMPLIANCE]: true,
    [FEATURE_ENABLE_INVOICING_PAYMENT_METHOD_SETTINGS]: true,
    [FEATURE_ENABLE_INVOICING_QUOTE_SERVICE]: true,
    [LRX_32023_MARK_ALL_ITEMS_FULFILLED]: false,
    inventory_special_orders: false,
    [FEATURE_SHOW_SPECIAL_ORDERS_IN_INVENTORY]: false,
    [FEATURE_NEW_TAX_EXEMPTION_ENABLED]: true,
    [FEATURE_BARCODE_FROM_SALE_ID]: true,
    [FEATURE_FULFILLMENT_TAKE_NOW_ITEM_PAYMENT_ENFORCEMENT]: true,
    [FEATURE_ALLOW_EDIT_UNFULFILLED_SALES]: true,
    [FEATURE_ALLOW_EDIT_UNFULFILLED_SALES_CANCEL_SALE]: true,
    [FEATURE_BARCODE_SCAN_ERROR_FIX]: true,
    [FEATURE_SSBO_ONBOARDING_COHORT]: false,
    [FEATURE_ON_ACCOUNT_PAYMENT_TYPE]: true,
    [FEATURE_ON_ACCOUNT_PAY_VIA_REGISTER]: true,
    [FEATURE_ENABLE_ACH_XSERIES]: true,
    [FEATURE_SURCHARGE_TRANSLATION]: false,
    [FEATURE_COMPLETE_PICKUP_AFTER_PAYMENT]: true,
    [FEATURE_REGISTER_BASEPRICE_AS_BESTPRICE]: true,
    [FEATURE_XMEN2565_RECEIPT_WEB_PRESENCE]: true,
    [FEATURE_FAILFAST_BULK_SOLD_BY]: true,
    [FEATURE_LSPAY_CNP_PAYMENTS]: true,
    [FEATURE_LSPAY_CP_CNP_SPLIT_ENTRY]: true,
    [LRX_28094_COLLAPSIBLE_CASH_COUNTING]: true,
    [LRX_39407_CHEQUE_REFERENCE_WRITE]: false,
    [LRX_39407_CHEQUE_REFERENCE_READ]: false,
    [FEATURE_LRX_38368_MIGRATE_LEGACY_VERSION_REGISTER_SALES_WEBREGISTER]: false,
    [FEATURE_LRX_42862_HIDE_ECOM_REGISTERS]: true,
    [FEATURE_REGISTER_PERF_OPTIMIZATIONS]: true,
    [LRX_23910_ENABLE_DEFAULT_VALUE_ON_BOOLEAN_CUSTOM_FIELD]: false,
    [FEATURE_INTEGRATED_PAYMENT_OVERPAYMENT_FIX]: false,
  },
}
